// src/lib/sms-catalog.js — Lot O4 : catalogue des gabarits SMS (vue admin).
//
// ⚠️ MIROIR CONTRÔLÉ (lecture seule, affichage uniquement) de :
//   - lib/sms-templates.js  (2 gabarits TRANSACTIONNELS du parcours)
//   - lib/marketing-sms.js  (2 gabarits MARKETING post-séjour : OTA + Direct)
// CRA bloque l'import direct de la racine lib/ depuis src/ → duplication
// contrôlée (même pattern que src/lib/inbox-channels.js). GARDER EN SYNC :
// tout changement de gabarit côté lib/ doit être répercuté ici (les textes
// affichés dans la vue SMS admin viennent d'ICI, jamais de la base) — l'anti-
// drift est testé (src/lib/sms-catalog-sync.test.js), byte-identique.
//
// ★ REFONTE 2026-07-27 (décision Dimitri) — 5 gabarits → 4 :
//   RETIRÉS : validation_lien (doublon de l'email), rappel_caution_j2 (pas
//   urgent + « que la caution » trompeur), confirmation_livret (remplacé par
//   instructions_arrivee, mieux placé la veille au soir).
//   AJOUTÉS  : instructions_arrivee (SMS 2), sms_post_sejour_direct (SMS 3b).
//
// Ce module ne fait AUCUN envoi — ce sont des métadonnées d'affichage.

// Conservé pour rétro-compat d'import (plus utilisé dans les textes 2026-07-21
// — préfixe/suffixe retirés, décision Dimitri).
export const SMS_SERVICE_MENTION = " SMS de service.";

export const SMS_CATALOG = [
  // ── Parcours — transactionnels (lib/sms-templates.js) ──
  {
    slug: "rappel_caution_j0",
    origin: "direct",
    kind: "transactionnel",
    label: "Jour J — réservation à finaliser",
    fr: "Bonjour {prenom}, c'est aujourd'hui qu'on vous accueille ! Il reste à finaliser votre réservation pour recevoir vos accès : {lien}",
    en: "Hi {prenom}, we welcome you today! Complete your booking to receive your access details: {lien}",
    es: "Hola {prenom}, hoy te damos la bienvenida! Falta completar tu reserva para recibir tus accesos: {lien}",
  },
  {
    slug: "instructions_arrivee",
    origin: "direct",
    kind: "transactionnel",
    label: "La veille — instructions d'arrivée disponibles",
    fr: "Bonjour {prenom}, vos instructions d'arrivée sont disponibles : {lien} - à demain !",
    en: "Hi {prenom}, your arrival instructions are available: {lien} - see you tomorrow!",
    es: "Hola {prenom}, ya puedes ver tus instrucciones de llegada: {lien} - hasta mañana!",
  },
  // ── Post-séjour — marketing (lib/marketing-sms.js) ──
  {
    slug: "sms_post_sejour_promo",
    origin: "ota",
    kind: "marketing",
    label: "Merci post-séjour + code promo -10 % (OTA)",
    fr: "Bonjour {prenom}, merci pour votre séjour, ce fut un plaisir ! -10% sur votre prochain séjour avec le code {code} : {lien}. Désinscription via ce lien.",
    en: "Hi {prenom}, thank you for your stay, it was a pleasure! -10% on your next stay with code {code}: {lien}. Unsubscribe via this link.",
    es: "Hola {prenom}, gracias por tu estancia, ha sido un placer! -10% en tu siguiente estancia con el vale {code}: {lien}. Unsubscribe en este enlace.",
  },
  {
    slug: "sms_post_sejour_direct",
    origin: "direct",
    kind: "marketing",
    label: "Merci post-séjour + justificatif (Direct, sans promo)",
    fr: "Bonjour {prenom}, merci pour votre séjour, ce fut un plaisir ! Votre justificatif est disponible ici : {lien}. Au plaisir de vous accueillir à nouveau. Désinscription via ce lien.",
    en: "Hi {prenom}, thank you for your stay, it was a pleasure! Your receipt is available here: {lien}. We hope to welcome you again. Unsubscribe via this link.",
    es: "Hola {prenom}, gracias por tu estancia, ha sido un placer! Puedes ver tu justificante en: {lien}. Un placer recibirte de nuevo. Unsubscribe en este enlace.",
  },
];
